(function () {
  'use strict';

  const header = document.getElementById('siteHeader');
  const btnToggle = document.querySelector('.js-nav-toggle');
  const navMenu = document.getElementById('navMenu');

  if (btnToggle && navMenu) {
    btnToggle.addEventListener('click', function () {
      const isOpen = navMenu.classList.toggle('is-open');
      btnToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      btnToggle.setAttribute(
        'aria-label',
        isOpen ? 'Cerrar menú de navegación' : 'Abrir menú de navegación'
      );
    });

    navMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (window.innerWidth <= 980) {
          navMenu.classList.remove('is-open');
          btnToggle.setAttribute('aria-expanded', 'false');
          btnToggle.setAttribute('aria-label', 'Abrir menú de navegación');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navMenu.classList.contains('is-open')) {
        navMenu.classList.remove('is-open');
        btnToggle.setAttribute('aria-expanded', 'false');
        btnToggle.focus();
      }
    });
  }

  if (header) {
    const ENTER_SCROLL_Y = 64;
    const EXIT_SCROLL_Y = 24;
    /** Viewport estrecho: header compacto fijo, sin estado scroll (coincide con CSS móvil). */
    const MOBILE_HEADER_MAX = 768;

    const isMobileHeaderViewport = function () {
      return window.innerWidth <= MOBILE_HEADER_MAX;
    };

    const toggleHeader = function () {
      if (isMobileHeaderViewport()) {
        header.classList.remove('is-scrolled');
        return;
      }

      const y = window.scrollY || window.pageYOffset || 0;
      const isScrolled = header.classList.contains('is-scrolled');

      // Histeresis para evitar parpadeo cerca del umbral.
      if (!isScrolled && y >= ENTER_SCROLL_Y) {
        header.classList.add('is-scrolled');
      } else if (isScrolled && y <= EXIT_SCROLL_Y) {
        header.classList.remove('is-scrolled');
      }
    };

    toggleHeader();
    window.addEventListener('scroll', toggleHeader, { passive: true });
    window.addEventListener('resize', toggleHeader);
  }
})();

(function () {
  'use strict';

  // ── Contador animado para .stat-card ──────────────────────────────────────
  // Solo ejecuta si existen elementos con data-counter en la página
  const contadores = document.querySelectorAll('[data-counter]');

  if (contadores.length > 0) {

    function animarContador(el) {
      const target   = parseInt(el.dataset.counter, 10);
      const suffix   = el.dataset.suffix  || '';
      const prefix   = el.dataset.prefix  || '';
      const duration = 2000;
      const steps    = 60;
      const increment = target / steps;
      let step    = 0;
      let current = 0;

      const timer = setInterval(function () {
        step++;
        current = Math.min(Math.round(increment * step), target);
        el.textContent = prefix + current + suffix;
        if (step >= steps) clearInterval(timer);
      }, duration / steps);
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animarContador(entry.target);
          // Solo anima una vez por elemento
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    contadores.forEach(function (el) {
      observer.observe(el);
    });

  }

})();